import React, { useState } from 'react'
import ppo from 'ppo'
import intl from 'react-intl-universal'
// avoid importing internal rc-menu types; use `any` for menu callback
import { LOCALE_CONFIG_MAP } from '@/config/index'
import { Dropdown } from 'antd'
import { DownOutlined } from '@ant-design/icons'
import styles from './index.module.scss'

//语言key类型
export type LocaleKeysType = keyof typeof LOCALE_CONFIG_MAP

const SelectLang:React.FC = () => {
  const intlOptions = intl.getInitOptions()
  const [selectedLang, setSelectedLang] = useState(intlOptions.currentLocale || '')

  const menuItemStyle = { minWidth: "160px" }
  const menuItemIconStyle = { marginRight: "8px" }

  const languageChange = (params: any) => {
    const language = params.key || (params.keyPath && params.keyPath[0])
    ppo.setCookie('kankan-lang', language)
    setSelectedLang(language)
    window.location.reload()
  }
  const items = Object.keys(LOCALE_CONFIG_MAP).map((key) => {
    const localeObj = LOCALE_CONFIG_MAP[key as LocaleKeysType]
    return {
      key: localeObj.lang,
      label: localeObj.label,
      style: menuItemStyle,
    }
  })

  return(
    <Dropdown trigger={["click"]} menu={{ items, onClick: languageChange, selectedKeys: [selectedLang] }}>
      <div className={styles['select-lang']}>
        {/* <span className={styles['select-item']}>{LOCALE_CONFIG_MAP[selectedLang as LocaleKeysType]?.icon}</span> */}
        <span className={styles['select-item']}>{LOCALE_CONFIG_MAP[selectedLang as LocaleKeysType]?.label}</span>
        <DownOutlined className={styles['select-icon']} />
      </div>
    </Dropdown>
  )
}

export default SelectLang